import React from "react";
import { Badge, BadgeProps } from "../Badge";
import { TypographyVariantsTypes } from "../../types/typography";
import { Typography } from "../Typography";
import s from "./ChipsNFilter.module.scss";
import cn from "classnames";

enum ChipsSize {
  small = "small",
  large = "large",
}

type ChipsSizeType = "small" | "large";

type ChipsNFilterProps = {
  label: string;
  size?: ChipsSizeType;
  isFilter?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  isActive?: boolean;
  leftIcon?: React.JSX.Element;
  rightIcon?: React.JSX.Element;
  badgeData?: BadgeProps & {
    show: boolean;
  };
  rootStyle?: React.CSSProperties;
  customStyle?: React.CSSProperties;
};

export function ChipsNFilter({
  label,
  size = "large",
  isFilter = false,
  isSelected = false,
  isDisabled = false,
  isActive = false,
  leftIcon = null,
  rightIcon = null,
  badgeData = null,
  rootStyle={},
  customStyle={}
}: ChipsNFilterProps) {
  const typographyVariant: Record<ChipsSize, TypographyVariantsTypes> = {
    small: "label_4_medium",
    large: "label_3_medium",
  };
  return (
    <div className={s.container} style={rootStyle}>
      <div
        className={cn(s.chips, s[size], {
          [s.selected]: isSelected,
          [s.disabled]: isDisabled,
          [s.filter]: isFilter,
          [s.active]: isActive,
        })}
        style={customStyle}
      >
        {leftIcon}
        <Typography
          className={s.label}
          label={label}
          variant={typographyVariant[size]}
        />
        {rightIcon}
      </div>
      {badgeData?.show && size === ChipsSize.large && (
        <div className={s.badge}>
          <Badge {...badgeData} />
        </div>
      )}
    </div>
  );
}
